'use strict';
//Danish
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': 'Input',
  'AUDIOCONTROLS-OUTPUT-HEADING': 'Udput',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Annuler',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Gem',
  'BACK-BTN-LABEL': 'Tilbage',
  'CALLCONTROLS-MUTE-BTN-LABEL' : 'Slå lyden fra',
  'CALLCONTROLS-HOLD-BTN-LABEL' : 'Holde',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Lyd',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Tastatur',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Overførsel',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'Nyt Opkald',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Læg På',
  'CALLLIST-NOCALL' : 'Ingen Aktivt opkald',
  'CANCEL-BTN-LABEL' : 'Annuler',
  'EMAIL-PLACEHOLDER' : 'Email adresse',
  'INCOMINGCALL-HEADER' : 'Indgående opkald',
  'INCOMINGCALL-ACCEPT' : 'Acceptere',
  'INCOMINGCALL-DECLINE' : 'Afslå',
  'INCOMINGCALL-VOICEMAIL' : 'Send til Voicemail',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :' Indtast email adresse',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'adgangskode',
  'LOGIN-CHECKBOX-LABEL' : 'Husk mig',
  'LOGIN-FORGOTPASSWORD-LINK' : 'Glemt adgangskode?',
  'LOGIN-SIGNIN-BTN-LABEL' : 'Log ind',
  'LOGIN-FORGOTPW-INFO-TEXT' : 'Indtast din email adresse for at nulstille din adgangskode.',
  'LOGIN-INPUT-PASSWORD-ERROR' : 'Indtast venligst komplet adgangskode',
  'LOGIN-INPUT-EMAIL-ERROR' : 'Indtast gyldig e-mail',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'adgangskoderne skal være ens',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'reset',
  'LOGIN-RESETPW-INFO-TEXT' : ', Skal du ændre din adgangskode. Password skal indeholde mindst ét bogstav , ingen mellemrum , ikke starte med @ , og 8 eller flere tegn .',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : 'Ny adgangskode',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : 'Gentag adgangskode',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'ændre',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'Annuler',
  'SETTINGS-VIEWALERT-BTN-LABEL' : 'Vis Advarsler',
  'SETTINGS-VERSION' : 'version ',
  'SETTINGS-HELPDOC-BTN-LABEL' : 'Hjælp Dokumentation',
  'SETTINGS-CHECKBOX-LABEL' : 'Aktivere',
  'SETTINGS-CHECKBOX-HEADER' : 'Altid på toppen?',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Luk Advarsler',
  'SETTINGS-LOGOUT-BTN-LABEL' : 'Log ud',
  'SETTINGS-SELECT-EXTENSION-HEADER': 'Udvidelse',
  'SETTINGS-SELECT-RINGTONE-HEADER': 'Ringetone',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Inputenhed',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Output-enhed',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Grænseflade Tema',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Grænseflade sprog',
  'CALLHISTORY-BACK-BTN-LABEL' : 'Tilbage',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Rydde',
  'CALLHISTORY-HEADER' : 'Historie',
  'CALLHISTORY-NO-HISTORY-MSG' : 'Ingen opkalds historie',
  'ALERTLOG-SETTINGS-BTN-LABEL' : 'Indstillinger',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'Rydde',
  'ALERTLOG-HEADER' : 'Advarsler',
  'ALERTLOG-NO-ALERT-MSG' : 'Ingen advarsler',
  'UTILITIES-STATUS-ONHOLD' : 'I venteposition',
  'UTILITIES-STATUS-MUTED' : 'Slå lyden fra',
  'UTILITIES-STATUS-ACTIVE' : 'Aktiv',
  'UTILITIES-STATUS-DIALING' : 'Ringer',
  'ALERTITEM-HEADING-LOGIN' : 'Log på',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'Det indtastede brugernavn eller kodeord er forkert.',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'Mistet netværksforbindelse. Tjek forbindelsesstatus.',
  'DIALINPUT-PLACEHOLDER-TEXT' : 'Indtast et nummer at ringe',
  'CALLDETAILS-HOLD' : 'I venteposition',
  'CALLDETAILS-MUTED': 'Slå lyden fra',
  'CALLLIST-STATUS-ACTIVE': 'Aktiv',
  'CALLLIST-STATUS-DIALING': 'Opkald',
  'CALLHISTORY-STATUS-FAILED': 'Fejlet',
  'HEADING-STATUS-CONNECTED' : 'Forbundet',
  'HEADING-STATUS-OFFLINE' : 'Offline',
  'BLIND-BTN-LABEL': 'Blind',
  'ATTENDED-BTN-LABEL': 'deltog',
  'SOFTPHONE-DTMF-COMMANDS': 'indtast nummeret',
  'ARIA-LOGIN-SIGNIN-BTN': 'Log ind knappen',
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': 'Glemt kodeord knappen',
  'ARIA-CANCEL-BTN': 'Annuller knappen',
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': 'Reset adgangskode knappen',
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': 'Ikke nu mærkat',
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'Tilbage mærkat',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'Ryd historik-mærkat',
  'ARIA-SETTINGS-LOGOUT-BTN': 'Log af knappen',
  'ARIA-SETTINGS-VIEWALERT-BTN': 'Vis advarsler knappen',
  'ARIA-SETTINGS-HELPDOC-BTN': 'Hjælp-dokumentation-knappen',
  'ARIA-RESETPW-CHANGE-BTN-LABEL': 'Skift adgangskode mærkat',
  'ARIA-BACKSPACE-BTN': 'Backspace knappen',
  'ARIA-DIALING-INPUT-FIELD': 'Opkald indtastningsfeltet',
  'ARIA-HEADER': 'Header',
  'ARIA-CLEAR-ALERTS-BUTTON': 'Knappen Ryd advarsler',
  'ARIA-ALERT-LIST': 'Alert liste',
  'ARIA-CHECKBOX': 'Afkrydsningsfelt',
  'ARIA-SAVE-BTN': 'Gem knappen',
  'ARIA-INPUT-FIELD': 'Input felt',
  'ARIA-INPUT': 'Input',
  'ARIA-KEYPAD': 'Tastatur',
  'ARIA-KEY': 'Nøgle',
  'ARIA-AUDIO-SLIDER': 'Juster Audio',
  'ARIA-AUDIO-SLIDER-CONTROL': 'Audio dkontrollen',
  'ARIA-MENU-ITEM': 'menupunkt',
  'ARIA-DROP-DOWN-MENU': 'Drop down menu',
  'ARIA-BADGE-BUTTON': 'Badge knap',
  'ARIA-CALL-DETAIL': 'Opkalds detalje',
  'ARIA-OPEN-SETTINGS-BUTTON': 'Åbn indstillinger knap',
  'UPDATE-HEADER': 'Opdatering til rådelighed',
  'UPDATE-MSG': 'Vil du gerne genstarte programmet nu?',
  'UPDATE-POSTPONE-BUTTON': 'Udskyd (1 min)',
  'UPDATE-UPDATE-BUTTON': 'Opdater',
  'ARIA-UPDATE-POSTPONE-BUTTON': 'Udskyd knap',
  'ARIA-UPDATE-UPDATE-BUTTON': 'opdater knap',
  'ACTIVECALL-STATUS-RINGING': 'Ringetone',
  'ACTIVECALL-STATUS-ACTIVE': 'Aktiv',
  'ACTIVECALL-STATUS-DIALING': 'Opkald',
  'ACTIVECALL-STATUS-FAILED': 'Fejlet',
  'LOGIN-INPUT-SHOW': 'At vise',
  'LOGIN-INPUT-HIDE': 'Skjule',
  'CALLHISTORY-TODAY': 'I dag',
  'CALLHISTORY-YESTERDAY': 'I går',
  'ALERT_FORGOT_PASSWORD': 'glemt adgangskode',
  'ALERT_SETTINGS_WILL_APPLY': 'Aktive opkald; indstillinger vil gælde, når ledig.',
  'ALERT_DIALING_OPTIONS': 'Opkaldsfunktioner',
  'ALERT_DIALING_OPTIONS_BODY': 'Manglende plan muligheder',
  'ALERT_LOGIN': 'Log på',
  'ALERT_SOFTPHONE_EXTENSION': 'Ingen softphone forlængelse',
  'ALERT_MORE_INFORMATION': 'For mere information besøg:',
  'ALERT_LOST_CONNECTION': 'Mistet netværksforbindelse. Tjek forbindelsesstatus.',
  'ARIA-PLAY-BTN': 'knappen Afspil',
  'ARIA-STOP-BTN': 'Stop-knap',
  'CONTACTS-STATUS-ONLINE': 'Online',
  'CONTACTS-STATUS-OFFLINE': 'Offline',
  'CONTACTS-STATUS-BUSY': 'Travl',
  'CONTACTS-STATUS-UNKNOWN': 'Ukendt',
  'LABELLEDINPUT-LABEL-EMAIL': "Email adresse",
  'LABELLEDINPUT-LABEL-PASSWORD': "Adgangskode",
  'LABELLEDINPUT-LABEL-TEXT': "Tekst",
  'LABELLEDINPUT-HINT-EMAIL': "Indtast en gyldig e-mail adresse nedenfor.",
  'LABELLEDINPUT-HINT-PASSWORD': "Indtast et gyldigt kodeord nedenfor.",
  'LABELLEDINPUT-HINT-TEXT': "Indtast tekst nedenfor.",
  'ARIA-ICON-AREA': 'Ikon Area',
  'SETTINGS-ADVANCED-LOGGING': "Avanceret logføring",
  'APPMENU-SETTINGS-BTN-LABEL': "Åbn indstillinger",
  'APPMENU-HELP-BTN-LABEL': "Hjælp dokumentation",
  'APPMENU-LOGOUT-BTN-LABEL': "Log ud",
  'APPMENU-VERSION': "version ",
  'HEADER-SETTINGS-TITLE': "Indstillinger",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Underretninger",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Udseende",
  'SETTINGS-CONTACTS-BTN-LABEL': "Kontakter",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Fejlfinding",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Juster, hvordan du modtager opdateringer.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Ændre udseendet af applikationen.",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Importer dine kontakter.",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Værktøjer til at hjælpe dig med at finde ud af, hvad der er galt",
  'ARIA-BACK-BTN-LABEL': "Tilbage",
  'HEADER-BACK-ARIA-LABEL' : 'tilbage',
  'ENTITYLIST-SEARCH-FOUND': "fundet.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "elementer",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'Ny gruppe',
  'ENTITYLIST-NO-CONTACTS-FOUND': 'Ingen kontakter fundet',
  'ENTITYLIST-TRY-IMPORTING': 'Prøv at importere eller tilføje en kontakt.',
  'ZEROSTATE-IMPORT-BTN-LABEL': 'Importere',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Indtast nummeret for at sende eller importere din kontaktliste i indstillinger.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Søg i kontaktpersoner",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Tilføj et nummer',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'Ingen kontaktoplysninger',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Tilføj et nummer for at komme i gang',
  'ARIA-CARD-DETAILS-EDIT': 'Redigere',
  'ARIA-CARD-DETAILS-DELETE': 'Slet',
  'SETTINGS-DEVICES-BTN-LABEL': "Enheder",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Skift hvordan dine enheder er konfigureret.",
  'HEADER-CONTACTS-ARIA-LABEL' : "kontakter",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Fejlfinding",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Aktivér avanceret logning",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "Når programmet er aktiveret, opretter applikationen avancerede logfiler, der hjælper med at diagnosticere applikationsfejl.",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : 'Avanceret logføring',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "Advarsler",
  "SETTINGS-VIEW-ALERTS-TITLE" : "Se advarsler",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "Få adgang til en registrering af advarsler og logfiler.",
  "SETTINGS-NOTIFICATIONS-TITLE": "Ringetone",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "Skift ringetone for indgående taleopkald.",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "Default",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "Lys",
  'APPMENU-DARK-THEME-BTN-LABEL': "Mørk",
  'SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP': "Altid på toppen",
  'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION': "Når aktiveret, vises applikationen altid over dine andre applikationer.",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Altid på toppen?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "Tema",
  'SETTINGS-THEMES-DESCRIPTION': "Temaer ændrer ansøgningens overordnede udseende.",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "Sprog",
  'SETTINGS-LANGUAGE-DESCRIPTION': "Ændring af sprog ændrer det gennem hele applikationen.",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "Device",
  'SETTINGS-CATEGORY-HEADER-CONTACTS': "Kontakter",
  'SETTINGS-CATEGORY-HEADER-APPEARANCE': "Udseende",
  'SETTINGS-CATEGORY-HEADER-NOTIFICATIONS': "Underretninger",
  'SETTINGS-INPUT-DEVICE-TITLE': "Input Device",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Indstil den lydenhed, du vil bruge til input.",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "Output Device",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Indstil den lydenhed, du vil bruge til udgang.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Importer dine kontakter",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Vælg din mulighed nedenfor for at importere kontakter.",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "Prøve CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "Ved at trykke på knappen nedenfor downloades en sample CSV-fil.",
  'SETTINGS-CONTACTS-BACKUP': 'Backup',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Ved at trykke på knappen nedenfor downloades en CSV-backup af dine kontakter. Dette anbefales før import.",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': 'Download Prøve',
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "Importeret",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Importere",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Download Backup',
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Tilføj kontakt',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Afbestille",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Slet",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "Er du sikker på, at du vil slette denne kontakt?",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "Hvis du gennemfører denne handling, fjernes den aktuelle kontaktes oplysninger permanent. ",
  'CONTACT-DETAILS-FORM-ERROR': 'Et felt i nedenstående formular har en fejl.',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Personlig information',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'Fornavn',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Indtast Fornavn',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'Efternavn',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Indtast efternavn',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Selskab',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': 'Indtast Firmanavn',
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Telefonnumre',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Tilføj telefon',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Afbestille',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'Gemme',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'Ny kontakt',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Rediger kontakt',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': 'Dette felt kan ikke efterlades tomt.',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Nummer',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Indtast venligst et gyldigt 10-cifret nummer',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Indtast nummer ...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'Foretrækkes?',
  'CONTACT-DETAILS-FORM-SELECT-HOME': 'Hjem',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'Forretning',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'Mobil',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': 'Andet',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Etiket',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Vælg det nummer, der skal ringes op',
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Foretrækkes',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP' : 'Indtast venligst et gyldigt nummer'
};
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-da.js